import React, {useState, useCallback, useEffect} from 'react';
import useMeasure from 'react-use-measure';
import VisibilitySensor from 'react-visibility-sensor';
import {motion} from 'framer-motion';
import Button3D from './Button3D';
import {ReactComponent as LogoB} from '../img/LogoB.svg';

const svg = {
  tap: {
    opacity: [0, 1, 1, 0],
    translateX: [0, -35, -35, -35],
    translateY: [0, -35, -35, -35],
    transition: {duration: 2, times: [0.1, 0.2, 0.93, 1]},
  },
};

export default function Home() {
  const [tap, setTap] = useState();

  return (
    <section className='home section' id='home'>
      <div className='home__container container grid'>
        <div className='home__data'>
          <motion.div
            initial={{y: -200, opacity: 0}}
            animate={{y: 0, opacity: 1}}
            transition={{type: 'spring', bounce: 0.7, duration: 2, delay: 0.3}}
          >
            <span className='home__greeting'>Hello, I'm</span>
            <h1 className='home__name'>Andrez Ramirez</h1>
            <h3 className='home__education'>FrontEnd Developer</h3>
          </motion.div>

          <div className='home__buttons'>
            <Button3D
              props={{
                href: require('../pdf/andrezr.pdf'),
                content: 'Download CV',
                download: 'Portfolio Andrez R',
              }}
            />
            <Button3D props={{href: '#about', content: 'About me'}} />
          </div>
        </div>
        <div className='home__logocontainer'>
          <Button3D
            props={{
              content: (
                <motion.div
                  onTapStart={() => {
                    setTap(false);
                    setTap(true);
                  }}
                  className='home__handle'
                >
                  <LogoB className='home__logo' />
                </motion.div>
              ),
              style: {borderRadius: 250, opacity: 1},
            }}
          />
          <div className='home__svgcontainer'>
            <motion.svg
              initial={{opacity: 0}}
              animate={tap ? 'tap' : {opacity: 0}}
              variants={svg}
              id='Bubble'
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 376.7 336.2'
            >
              <g data-name='Capa 1'>
                <path
                  fill='#fff'
                  d='m237.78 289.3-8.77 1.68a215.04 215.04 0 0 1-40.61 3.82C90.03 294.8 10 230.92 10 152.4S90.03 10 188.4 10c47.9 0 92.94 15.08 126.79 42.45 33.22 26.86 51.51 62.29 51.51 99.75 0 42.24-23.38 82.07-64.15 109.28l-10.95 7.41v50.31Z'
                />
                <path d='M188.4 20a205.19 205.19 0 0 1 66.72 10.92 175.68 175.68 0 0 1 53.78 29.3c30.82 24.93 47.8 57.6 47.8 91.98 0 38.84-21.76 75.64-59.7 100.97l-.05.03-.06.04-6.5 4.4-8.79 5.95v38.62l-35.78-19.9-6.36-3.52-7.13 1.37-5.21 1a209.16 209.16 0 0 1-105.5-7.27 175.53 175.53 0 0 1-53.8-29.3C36.98 219.64 20 186.9 20 152.4c0-34.48 16.98-67.2 47.82-92.15a175.62 175.62 0 0 1 53.8-29.33A205.44 205.44 0 0 1 188.4 20m0-20C84.5 0 0 68.4 0 152.4c0 84.1 84.5 152.4 188.4 152.4a224.9 224.9 0 0 0 42.5-4l5.2-1 65.5 36.4v-62l6.5-4.4c43.6-29.1 68.6-72 68.6-117.6C376.7 68.4 292.2 0 188.4 0Z' />
                <path d='M184.45 113.22v70.2h-17.1v-28.9h-26.6v28.9h-17.1v-70.2h17.1v27.5h26.6v-27.5Zm13.55 5.95a8.58 8.58 0 0 1-2.85-6.54 8.7 8.7 0 0 1 2.85-6.66 10.37 10.37 0 0 1 7.35-2.65 10.24 10.24 0 0 1 7.25 2.65 8.7 8.7 0 0 1 2.85 6.66 8.58 8.58 0 0 1-2.85 6.54 10.22 10.22 0 0 1-7.25 2.65 10.36 10.36 0 0 1-7.35-2.65Zm15.85 8.46v55.8h-17.1v-55.8Zm18.55 53.94a8.59 8.59 0 0 1-2.85-6.55 8.86 8.86 0 0 1 2.85-6.7 10.26 10.26 0 0 1 7.35-2.7 10.12 10.12 0 0 1 7.25 2.7 8.86 8.86 0 0 1 2.85 6.7 8.59 8.59 0 0 1-2.85 6.55 10.23 10.23 0 0 1-7.25 2.65 10.37 10.37 0 0 1-7.35-2.65Zm16.35-70.85-2 47.9h-14.5l-2-47.9Z' />
              </g>
            </motion.svg>
          </div>
        </div>

        <div className='home__social'>
          <a
            href='https://www.linkedin.com/in/andrezramirez/'
            target='_blank'
            className='home__social-link'
          >
            <i className='bx bxl-linkedin-square'></i>
          </a>
          <a
            href='https://github.com/andrezzz2312'
            target='_blank'
            className='home__social-link'
          >
            <i className='bx bxl-github'></i>
          </a>
        </div>
        <a href='#about' className='home__scroll'>
          <i className='bx bx-mouse home__scroll-icon'></i>
          <span className='home__scroll-name'>Scroll Down</span>
        </a>
      </div>
    </section>
  );
}
